// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.addProjectRoot[data-v-6d1f67b5]\n{\n\tmargin: 10px;\n\tmin-width: 260px;\n}\n.title[data-v-6d1f67b5]\n{\n\tborder-bottom: 1px solid #000000;\n\tmargin-bottom: 10px;\n\tfont-size: 20px;\n}\n.buttonRow[data-v-6d1f67b5]\n{\n\tmargin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
